import { useMemo } from 'react';
import { AnyResourceDefinition } from '../resources/types';

export const useKey = (resource?: AnyResourceDefinition, params?: any) =>
  useMemo(() => resource?.identifyInstance(params) ?? '', [resource, params]);
